import {
  Component,
  Input,
  ViewChild,
  forwardRef,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MyRenderer } from '@shared/inline-edit/inline-edit.service'
import { SharedService } from '@shared/shared.service';
import { environment } from '@myenv/environment';
import { FormControl } from '@angular/forms';

const INLINE_EDIT_CONTROL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => InlineEditComponent),
  multi: true
};

@Component({
    selector: 'app-inline-edit',
    templateUrl: './inline-edit.component.html',
    providers: [INLINE_EDIT_CONTROL_VALUE_ACCESSOR],
    styleUrls: ['./inline-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InlineEditComponent implements ControlValueAccessor, OnInit {
  @ViewChild('inlineEditControl') inlineEditControl: any; // input DOM element
  @Input() labelClass: any;  // Label value for input element
  @Input() item: any;  // complete value
  @Input() key!: string;  // Label value for input element
  @Input() formClass: any;  // Label value for input element
  @Input() label: string = '';  // Label value for input element
  @Input() type: string = 'text'; // The type of input element
  @Input() required: boolean = false; // Is input requried?
  @Input() disabled: boolean = false; // Is input disabled?
  patternValidation: boolean = false; // Is input disabled?
  @Input() saveData: any = Function.prototype;
  @Input() permissions!: boolean;
  @Input() index: any = Number;
  @Input() maxLength: any = Number;
  private selectedValue!: string; // Private variable for input value
  private selectedIndex!: Number; // Private variable for input value
  private _value: string = ''; // Private variable for input value
  private preValue: string = ''; // The value before clicking to edit
  editing: boolean = false; // Is Component in edit mode?
  public onChange: any = Function.prototype; // Trascend the onChange event
  public onTouched: any = Function.prototype;
  responseMessage: any = {};
  pattern: any;
  public dateFormat = environment.isoDateTimeFormat;

  constructor(
    private _renderer: MyRenderer,
    private sharedService: SharedService
  ) {
    document.addEventListener('click', () => {
      if (this.editing == true) {
        this.showErrorMsg();
      }
    });
  }

  ngOnInit() {
  }

  selectPattern() {
    if (this.item) {
      if (this.item.type == 'INTEGER' || this.item.type == 'LONG') {
        this.pattern = '^[0-9]+$';
      } else if (this.item.type == 'FLOAT' || this.item.type == 'DOUBLE') {
        this.pattern = '^[+-]?([0-9]*[.])?[0-9]+$';
      }
    }
  }

  checkPattern(e: any) {
    e.stopPropagation();
    this.value = this.value.replace(/,/g, '');
    const found = this.value.match(this.pattern);
    if (found == null && this.value) {
      this.patternValidation = true;
    } else {
      this.patternValidation = false;
    }
  }

  get value(): any {
    return this._value;
  }

  // currentValue(): any {
  //   return this._value;
  // }

  showErrorMsg() {
    document.getElementById('selectedId')!.classList.add('alerts-border');
    document.getElementById('saveDiv')!.classList.add('alerts-border');
    document.getElementById('rejectDiv')!.classList.add('alerts-border');
  }

  set value(v: any) {
    if (v !== this._value) {
      this._value = v;
      this.selectedIndex = this.index;
      this.onChange(v);
    }
  }

  // Required for ControlValueAccessor interface
  writeValue(value: any) {
    this._value = value;
  }

  // Required forControlValueAccessor interface
  public registerOnChange(fn: (_: any) => {}): void {
    this.onChange = fn;
  }

  // Required forControlValueAccessor interface
  public registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }

  // Do stuff when the input element loses focus

  onBlur() {
    if (this.permissions && !this.patternValidation) {
      this.editing = false;
      if (this.index == this.selectedIndex) {
        if (this.value == undefined) {
          return
        } else if (this.value != this.selectedValue) {
          if (this.required == true && !this.value) {
            this.value = this.selectedValue;
            this.editing = false;
          } else {
            if (this.value == '') {
              this.value = null;
            }
            this.value = {
              value: this.value,
              key: this.key
            }
            let payload = this.value;
            this.saveData(this.value);
            this.value = this.value.value;
          }
        }
      }
    }
  }

  // Start the editting process for the input element
  edit(value: any) {
    if (this.item.editable) {
      if (this.disabled) {
        return;
      }
      var elementExists = document.getElementById('selectedId');
      if (elementExists == null) {
        // if (this.editing == false) {
        this.selectedValue = this.value;
        this.preValue = value;
        if (this.permissions) {
          this.selectPattern();
          this.editing = true;
          // Focus on the input element just as the editing begins
          if (this.inlineEditControl) {
            setTimeout((_: any) => this._renderer.invokeElementMethod(this.inlineEditControl, 'focus'));
          }
        }
      } else {
        this.showErrorMsg();
      }
    }
  }

  previousValue(e: any) {
    e.stopPropagation();
    this.value = this.selectedValue;
    this.editing = false;
  }
}
